import './AbroadPaymentDetails.scss';
import { CorrespondentBanksSection } from './CorrespondentBanksSection';
import { PaymentDetailsSection } from './PaymentDetailsSection';
import { PublishedForeignBankDetailsDto } from '@/types/public/donate-page';
import { Currency } from '@/types/common/currency';
import { ABROAD_PAYMENT_DETAILS } from '@/const/public/donate-page';
import { currencyToString } from '@/utils/functions/mappers/public/donate/donate';
import { useTranslation } from 'react-i18next';

type AbroadCurrency = 'USD' | 'EUR';

interface AbroadPaymentDetailsProps {
    currency: Exclude<Currency, Currency.UAH>;
    foreignBankDetails: PublishedForeignBankDetailsDto[];
}

export const AbroadPaymentDetails = ({ currency, foreignBankDetails }: AbroadPaymentDetailsProps) => {
    const { t } = useTranslation('donatePage');
    if (!foreignBankDetails.length) {
        return null;
    }

    const sortedForeignBankDetails = foreignBankDetails.toSorted((a, b) => b.id - a.id);
    const currencyString = currencyToString(currency) as AbroadCurrency;
    const title = t(`${currencyString}_PAYMENT_DETAILS_LABEL`);
    const ibanLabel = ABROAD_PAYMENT_DETAILS[`IBAN_${currencyString}_LABEL`];

    return (
        <div className="abroadPaymentDetails">
            {sortedForeignBankDetails.map((bank, index) => (
                <div key={bank.id} className={`bankGroup ${index > 0 ? 'separated' : ''}`}>
                    <PaymentDetailsSection
                        title={index === 0 ? title : ''}
                        ibanLabel={ibanLabel}
                        ibanValue={bank.ukrainianIban}
                        receiverName={bank.receiver}
                        bankName={bank.name}
                        swift={bank.swift}
                        address={bank.address}
                    />

                    <CorrespondentBanksSection correspondentBanks={bank.correspondentBanks || []} />
                </div>
            ))}
        </div>
    );
};
